// iter160 — Admin list of Toolkit-linked accounts with per-user Unlink.
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Unlink } from "lucide-react";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SsoLinkedAccounts = () => {
  const [rows, setRows] = useState([]);
  const [busyId, setBusyId] = useState("");

  const load = async () => {
    try { const r = await axios.get(`${API}/sso/admin/linked`); setRows(r.data.accounts || []); }
    catch { toast.error("Could not load linked accounts"); }
  };
  useEffect(() => { load(); }, []);

  const unlink = async (id) => {
    setBusyId(id);
    try { await axios.post(`${API}/sso/admin/unlink/${id}`); toast.success("Account unlinked"); await load(); }
    catch { toast.error("Could not unlink"); }
    finally { setBusyId(""); }
  };

  return (
    <div className="mt-4 max-h-72 overflow-auto" data-testid="sso-linked-table">
      <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-ink-700">Toolkit-linked accounts ({rows.length})</p>
      <table className="w-full min-w-[520px] text-xs">
        <thead className="bg-sand-100 text-left text-ink-700">
          <tr><th className="p-2">Name</th><th className="p-2">Phone</th><th className="p-2">Linked</th><th className="p-2">How</th><th className="p-2" /></tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className="border-t border-border" data-testid={`sso-linked-row-${r.id}`}>
              <td className="p-2">{r.name || "—"}</td>
              <td className="p-2 font-mono">••{r.phoneLast4}</td>
              <td className="p-2 font-mono">{(r.linkedAt || "").slice(0, 10) || "—"}</td>
              <td className="p-2">{r.via === "confirmed" ? "Password confirmed" : "New via Toolkit"}</td>
              <td className="p-2 text-right">
                <Button size="sm" variant="outline" disabled={busyId === r.id} onClick={() => unlink(r.id)} data-testid={`sso-unlink-btn-${r.id}`}>
                  <Unlink className="mr-1 h-3 w-3" /> Unlink
                </Button>
              </td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={5} className="p-4 text-center text-ink-700" data-testid="sso-linked-empty">No linked accounts.</td></tr>}
        </tbody>
      </table>
    </div>
  );
};
